import styles from 'styles/Spinner.module.css'

const Spinner = ({ small }) => (
    <div className={`${styles['lds-spinner']}${small ? ' ' + styles.small : ''}`}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
)

export default Spinner
